<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="yellow">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Votación</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-2">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="6">
              <img :src="`https://api.icssa.com.ar/extras/fotosalmanaque/${this.foto}`
                " width="380" height="380" />
            </v-col>
          </v-row>
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="6">
              <h6>Foto: {{ this.foto }}</h6>
            </v-col>
          </v-row>
          <v-row dense align="center">
            <v-col cols="3" sm="3" md="3">
              <v-text-field label="Legajo" dense v-model="legajo">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card color="green" dark tile>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="guardarvotacion">Guardar</v-btn>

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../../src/axios-auth";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    legajo: "",
  }),
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  props: ["visible", "foto", "path"],
  methods: {
    vaciarModels() {
      this.foto = "";
      this.legajo = "";
    },

    guardarvotacion() {
      this.$swal({
        title: "Registrar Votación",
        text: "¿Desea registrar la votación?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          var datosVoto = {
            id: this.id,
            legajo: this.legajo,
            foto: this.foto,
          };

          let self = this;
          axios
            .put("/ICSSA/Guardarvotacion", datosVoto)
            .then((response) => {
              self.mensaje = response.data;
              self.$refs.form.resetValidation();
              self.showAlert({
                icon: "success",
                // title: "Ejecución guardada con éxito",
                title: self.mensaje,
                vm: self,
                time: "5000",
              });
              self.vaciarModels();
              self.$emit("close");
            })
            .catch({});
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
